import * as React from "react";
import { SVGProps } from "react";

type CheckDateIconProps = SVGProps<SVGSVGElement> & {
  circleColor?: string;
  iconColor?: string;
};

const CheckDateIcon = (props: CheckDateIconProps) => {

    const { height = 32, width = 32, 
        circleColor = 'white', iconColor = 'black', ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="checl end date">
        <rect width={32} height={32} fill="white" />
        <g id="calender-body">
          <rect
            id="main-part"
            x={2.25}
            y={4.25}
            width={25.5}
            height={23.5}
            rx={1.75}
            stroke="black"
            strokeWidth={0.5}
          />
          <path
            id="upper-part"
            d="M4 4.25H26C26.9665 4.25 27.75 5.0335 27.75 6V8.75H2.25V6C2.25 5.0335 3.0335 4.25 4 4.25Z"
            fill="#D9D9D9"
            stroke="black"
            strokeWidth={0.5}
          />
          <g id="dates">
            <line
              id="line 1"
              x1={4.5}
              y1={12.5}
              x2={7.5}
              y2={12.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 2"
              x1={10.5}
              y1={12.5}
              x2={13.5}
              y2={12.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 3"
              x1={16.5}
              y1={12.5}
              x2={19.5}
              y2={12.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 5"
              x1={4.5}
              y1={15.5}
              x2={7.5}
              y2={15.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 8"
              x1={4.5}
              y1={18.5}
              x2={7.5}
              y2={18.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 9"
              x1={4.5}
              y1={21.5}
              x2={7.5}
              y2={21.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 10"
              x1={4.5}
              y1={24.5}
              x2={7.5}
              y2={24.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 6"
              x1={10.5}
              y1={15.5}
              x2={13.5}
              y2={15.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 11"
              x1={10.5}
              y1={18.5}
              x2={13.5}
              y2={18.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 12"
              x1={10.5}
              y1={21.5}
              x2={13.5}
              y2={21.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 13"
              x1={10.5}
              y1={24.5}
              x2={13.5}
              y2={24.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 7"
              x1={16.5}
              y1={15.5}
              x2={19.5}
              y2={15.5}
              stroke="black"
              strokeLinecap="round"
            />
            <line
              id="line 4"
              x1={22.5}
              y1={12.5}
              x2={25.5}
              y2={12.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
        </g>
        <g id="calender-pages-holders">
          <line
            id="Line 7"
            x1={22.5}
            y1={3.5}
            x2={22.5}
            y2={5.5}
            stroke="black"
            strokeLinecap="round"
          />
          <line
            id="Line 8"
            x1={17.5}
            y1={3.5}
            x2={17.5}
            y2={5.5}
            stroke="black"
            strokeLinecap="round"
          />
          <line
            id="Line 9"
            x1={12.5}
            y1={3.5}
            x2={12.5}
            y2={5.5}
            stroke="black"
            strokeLinecap="round"
          />
          <line
            id="Line 10"
            x1={7.5}
            y1={3.5}
            x2={7.5}
            y2={5.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="circle">
          <circle
            id="inner-circle"
            cx={23.5}
            cy={22.5}
            r={7.25}
            fill={circleColor || "#D9D9D9"}
            stroke={iconColor || "black"}
            strokeWidth={0.5}
          />
          <path
            id="icon"
            d="M22.419 24.3409V24.2855C22.4252 23.6977 22.4868 23.2299 22.6037 22.8821C22.7207 22.5343 22.8869 22.2527 23.1023 22.0373C23.3177 21.8218 23.5762 21.6233 23.8779 21.4418C24.0594 21.331 24.2226 21.2002 24.3672 21.0494C24.5119 20.8955 24.6257 20.7185 24.7088 20.5185C24.795 20.3184 24.8381 20.0968 24.8381 19.8537C24.8381 19.5521 24.7673 19.2905 24.6257 19.0689C24.4842 18.8473 24.2949 18.6765 24.0579 18.5565C23.8209 18.4364 23.5578 18.3764 23.2685 18.3764C23.0161 18.3764 22.773 18.4287 22.5391 18.5334C22.3052 18.638 22.1097 18.8027 21.9528 19.0273C21.7958 19.252 21.705 19.5459 21.6804 19.9091H20.5171C20.5417 19.3859 20.6771 18.9381 20.9233 18.5657C21.1726 18.1933 21.5004 17.9086 21.9066 17.7116C22.3159 17.5147 22.7699 17.4162 23.2685 17.4162C23.8101 17.4162 24.281 17.5239 24.6811 17.7393C25.0843 17.9548 25.3951 18.2502 25.6137 18.6257C25.8352 19.0012 25.946 19.429 25.946 19.9091C25.946 20.2476 25.8937 20.5539 25.7891 20.8278C25.6875 21.1017 25.5398 21.3464 25.3459 21.5618C25.1551 21.7772 24.9243 21.968 24.6534 22.1342C24.3826 22.3035 24.1656 22.482 24.0025 22.6697C23.8394 22.8544 23.7209 23.0745 23.647 23.3299C23.5732 23.5853 23.5332 23.9039 23.527 24.2855V24.3409H22.419ZM23.01 27.0739C22.7822 27.0739 22.5868 26.9923 22.4237 26.8292C22.2605 26.6661 22.179 26.4706 22.179 26.2429C22.179 26.0151 22.2605 25.8197 22.4237 25.6566C22.5868 25.4935 22.7822 25.4119 23.01 25.4119C23.2377 25.4119 23.4331 25.4935 23.5962 25.6566C23.7594 25.8197 23.8409 26.0151 23.8409 26.2429C23.8409 26.3937 23.8025 26.5322 23.7255 26.6584C23.6516 26.7846 23.5516 26.8861 23.4254 26.9631C23.3023 27.0369 23.1638 27.0739 23.01 27.0739Z"
            fill={iconColor || "black"}
          />
        </g>
      </g>
    </svg>
  );
}

export default CheckDateIcon;